import api from '.'

/**
 * ReportingDashboardApi class provides methods to interact with the reporting dashboard API.
 *
 * This class includes functionalities for fetching, updating, and managing reporting data related
 * to the dashboard. It serves as a bridge between the frontend and the backend API, ensuring that
 * data operations are handled efficiently.
 */
class ReportingDashboardApi {
    /**
     * Fetches extraction data for a specified dashboard.
     *
     * @param {string} dashboard_id - The ID of the dashboard.
     * @param {string} id - The specific identifier.
     * @param {string} extract_id - The extraction identifier.
     * @param {string} subset_key - The subset key for the extraction.
     * @param {Array} common_filters - Common filters to apply.
     * @param {Array} extract_filters - Filters specific to the extraction.
     * @param {Object} parameters - Additional parameters for the request.
     * @param {boolean} overwrite_campaign_budget - Flag to overwrite campaign budget.
     * @param {Object} customCancelToken - Token to cancel the request if needed.
     * @returns {Promise<Object>} Response data from the API.
     */
    getExtractData(
        dashboard_id,
        id,
        extract_id,
        subset_key,
        common_filters,
        extract_filters,
        parameters,
        overwrite_campaign_budget,
        customCancelToken
    ) {
        const payload = {
            dashboard_id,
            id,
            extract_id,
            subset_key,
            common_filters,
            extract_filters,
            parameters,
            overwrite_campaign_budget
        }

        return api
            .sentRequest(
                '/api/report/dashboard',
                payload,
                true,
                null,
                customCancelToken
            )
            .then((res) => {
                return res.data
            })
            .catch((err) => {
                console.error('[Auth Api]: ', err)
                return api.getCatchResponse(err)
            })
    }
}

export const reportingDashboardApi = new ReportingDashboardApi()
